<template>
  <s-filter
    :active="!!model"
    :label
    :activeLabel
    :value="model?.toString()"
    @clear="model = undefined"
    :disabled
  >
    <template #value>
      <slot name="value">{{ model }}</slot>
    </template>
    <template #default="{close}">
      <div class="w-full max-w-[80vw]">
        <div class="flex flex-col min-w-[16rem] w-full">
          <div class="p-4 flex flex-col gap-3">
            <div class="flex flex-col gap-1.5">
              <s-input-field
                :id
                :aria-label="label"
                type="number"
                v-model.number="internal"
                :prefix
                :suffix
              />
            </div>
          </div>
          <s-btn
            class="!rounded-t-none !rounded-b-lg"
            @click.stop="
              model = internal;
              close();
            "
            icon="filter"
          >
            {{ $t('filter.apply') }}
          </s-btn>
        </div>
      </div>
    </template>
  </s-filter>
</template>
<script setup lang="ts">
import SFilter from '../SFilter.vue';
import SBtn from '../SBtn.vue';
import SInputField from '../SInputField.vue';
import {ref} from 'vue';

defineProps<{
  id: string;
  disabled?: boolean;
  label: string;
  activeLabel?: string;
  prefix?: string;
  suffix?: string;
}>();

const emit = defineEmits(['clear']);

const model = defineModel<number>();

const internal = ref();
</script>
